import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const TITLES = {
  door_limit_reached: "Door limit reached",
  trial_expired: "Your free trial has ended",
  feature_locked: "Upgrade to unlock this feature",
};

// Global modal triggered whenever the backend returns a 402 plan-limit error
// (dispatched by the axios interceptor as a `fdc:plan-limit` event). Gives a
// clear value prop + a single CTA to the plans page instead of a raw toast.
export default function UpgradeDialog() {
  const [info, setInfo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const onLimit = (e) => setInfo(e.detail || {});
    window.addEventListener("fdc:plan-limit", onLimit);
    return () => window.removeEventListener("fdc:plan-limit", onLimit);
  }, []);

  const open = !!info;
  const title = (info && TITLES[info.code]) || "Upgrade to unlock";
  return (
    <Dialog open={open} onOpenChange={(o) => !o && setInfo(null)}>
      <DialogContent data-testid="upgrade-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Sparkles className="h-5 w-5 text-amber-500" /> {title}
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-slate-600">
          {info?.detail || "This feature isn't included in your current plan. Subscribe to unlock it."}
        </p>
        <DialogFooter>
          <Button variant="ghost" onClick={() => setInfo(null)} data-testid="upgrade-dialog-dismiss">
            Not now
          </Button>
          <Button
            onClick={() => { setInfo(null); navigate("/settings?tab=subscription"); }}
            data-testid="upgrade-dialog-cta"
          >
            View plans
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
